import React from 'react';
import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import esLocale from "date-fns/locale/es";
import Box from '@mui/material/Box';
import dateToString from '../../helpers/dateToString';
import { useTheme } from '@mui/material';

const PREFIX = 'DateRangeSelectItem';

const classes = {
    date: `${PREFIX}-date`,
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.date}`]: {
        fontSize: '10px' /*aparantly its ignored? */
    },
}));

function DateRangeSelect(props) {

    const {
        fromDate,
        untilDate,
        handleFromDateChange,
        handleUntilDateChange,
        required,
        minDateFrom,
        maxDateFrom,
        minDateUntil,
        maxDateUntil,
    } = props;
    const theme = useTheme();

    var requiredAsterisk = null;
    if (required) {
        requiredAsterisk = <Box color="error.main"> *</Box>;
    }
    
    var minDateFromString = dateToString(minDateFrom);
    var maxDateFromString = dateToString(maxDateFrom);

    var minDateUntilString = dateToString(minDateUntil);
    var maxDateUntilString = dateToString(maxDateUntil);

    var untilColor = untilDate === null ? theme.palette.filter.main: theme.palette.filter.secondary;
    var fromColor = fromDate === null ? theme.palette.filter.main: theme.palette.filter.secondary;

    return (
        <Root>
            <Typography component={'div'} sx={{fontSize: theme.typography.pxToRem(14)}}>
                <div style={{ display: "flex" }}>
                    Escoge un rango de fechas {requiredAsterisk}
                </div>

            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={1} >
                    <Grid item xs={6}>
                        <DatePicker 
                            disableToolbar
                            autoOk
                            format="dd/MM/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label={<Typography color={fromColor}>Desde</Typography>}
                            locale='es-ES'
                            value={fromDate}
                            onChange={handleFromDateChange}
                            placeholder="dd/mm/aaaa"
                            InputLabelProps={{
                                shrink: true,
                              }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            minDate={minDateFrom}
                            maxDate={maxDateFrom}
                            minDateMessage={"La fecha debe ser después de la fecha mínima: " + minDateFromString}
                            maxDateMessage={"La fecha debe ser antes de la fecha máxima: " + maxDateFromString}
                            invalidDateMessage={"Formato de fecha inválido."}
                            slotProps={{ 
                                textField: { 
                                    variant: 'standard'
                                } 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DatePicker 
                            locale='es-ES'
                            className={classes.date}
                            disableToolbar
                            autoOk
                            format="dd/MM/yyyy"
                            placeholder="dd/mm/aaaa"
                            margin="normal"
                            id="date-picker-inline"
                            InputLabelProps={{
                                shrink: true,
                              }}
                            label={<Typography color={untilColor}>Hasta</Typography>}
                            value={untilDate}
                            onChange={handleUntilDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            minDate={minDateUntil}
                            maxDate={maxDateUntil}
                            minDateMessage={"La fecha debe ser después de la fecha seleccionada en ''Desde'': " + minDateUntilString}
                            maxDateMessage={"La fecha debe ser antes de la fecha máxima: " + maxDateUntilString}
                            invalidDateMessage={"Formato de fecha inválido."}
                            slotProps={{ 
                                textField: { 
                                    variant: 'standard'
                                } 
                            }}
                        />

                    </Grid>
                </Grid>

            </LocalizationProvider>
        </Root>
    );
}

function DateRangeSelectItem(props) {
    return (
        <div>
            <ListItem>
                <ListItemText primary={
                    <DateRangeSelect
                        {...props}
                    />
                } />
            </ListItem>
            <Divider />
        </div>
    )
}

export default DateRangeSelectItem;